<template>
    <div>
        <div class="px-0 mx-0 " cols="12" style="background-color:darkblue;border-bottom-right-radius:650px">
            <v-row no-gutters></v-row>
            <v-row class="mt-6" no-gutters>
                <v-col cols="3" class="mr-16">
                    <v-row no-gutters>
                        <v-img :src="getLogo" max-height="35" max-width="45" class=" mt-8"></v-img>
                        <h2 class="mt-9 mr-2" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:25px">آسا سرویس</h2>
                    </v-row>
                </v-col>
                <v-col class="mr-16">
                    <v-row class="mt-10 mr-16" no-gutters>
                        <h6 class="ml-6" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px">امکانات ویژه</h6>
                        <h6 class="ml-6" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px">معرفی</h6>
                        <h6 class="ml-6" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px">پیشنهاد ویژه</h6>
                        <h6 class="ml-6" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px">دانلود اپلیکیشن</h6>
                        <h6 class="ml-6" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px">دانلود نرم افزار</h6>
                        <h6 class="ml-6" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px">پیش نمایش</h6>
                        <v-btn elevation="16" style="font-family: 'Yekan-Bakh-Regular';font-size:15px;font-weight:bold "
                               rounded class="mr-16 mt-n2 btnanimation"
                               text v-ripple="{ class: 'primary--text' }">ورود به سامانه</v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters class="mt-16">
                <v-col cols="1"></v-col>
                <v-col class="mt-16 mr-n2">
                    <h1 style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:35px"> آسا سرویس</h1>
                    <h2 class="mt-8" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:28px">اپلیکیشن <span style="color:#FFDE03">جامع</span> مدیریت مراکز تعویض روغن</h2>
                    <br />
                    <v-btn elevation="4"
                           outlined
                           dark
                           x-large
                           rounded>دانلود اپلیکیشن</v-btn>
                </v-col>
                <v-col cols="6" class="mt-16 d-flex child-flex">
                    <v-row no-gutters class="">
                        <v-col cols="6">
                            <v-img :src="phone" max-height="630" max-width="390" Contain class="ml-n10 myanimation"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img :src="phone" max-height="630" max-width="390" Contain class="ml-n10 myanimation"></v-img>
                        </v-col>


                    </v-row>
                </v-col>
            </v-row>
        </div>
        <v-row no-gutters class="mt-16">
            <v-spacer></v-spacer>
            <v-col cols="4" xs="12" sm="12" md="4" lg="4" xl="4" class="mt-16">
                <h1 style="font-size:40px; font-family: 'Yekan-Bakh-Regular';text-align:justify" class="mt-16">معرفی آساسرویس به زبان ساده</h1>
                <h4 style="font-size:15px; font-family: 'Yekan-Bakh-Regular';color:#7B7B7B" class="mt-10">تمامی صاحبان کسب و کار در هر شغلی به دنبال جذب مشتری بیشتر و قوی تر کردن کسب و کار خود هستند. با توجه به رقابت موجود در بازار برای افزایش درآمد و سود دهی بیشتر نیاز به یک مدیریت قوی جهت ارائه خدمات با کیفیت بالاتر، ارتباط بهتر با مشتریان، ارائه خدمات جدید و خلاقانه، تخفیفات مناسب،استفاده از تکنولوژی های نوین و زیرساخت های موجود عمومی به شدت احساس می شود. </h4>
                <h4 style="font-size:15px; font-family: 'Yekan-Bakh-Regular';color:#7B7B7B" class="mt-10">آسا سرویس یک سامانه هوشمند تخصصی مبتنی بر تلفن همراه می باشد که جهت مدیریت و نظارت بر کلیه فرآیندها در اتوسرویس ها و مراکز تعویض روغن توسط کارشناسان مجرب شرکت آسمان کارمانیا نیازسنجی، طراحی،تولید و به بهره برداری رسیده است. در این سامانه صاحبان این نوع مشاغل از طریق تلفن همراه خود فرآیندهای مربوط به امور مشتریان،امور مالی و انبارداری کسب و کار خود را مدیریت و کنترل می نمایند.</h4>
                <v-btn elevation="2" class="mt-10 btnanimation"
                       large
                       outlined
                       rounded>
                    ادامه مطلب
                    <v-icon dark class="btnanimationicon"
                            right>
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
            </v-col>
            <v-col cols="1" sm="0" xs="0" md="1" lg="1" xl="1"></v-col>
            <v-col cols="5" xs="12" sm="12" md="5" lg="5" xl="5" :style="{ 'background-image': 'url(' + background1 + ')' }">
                <br />
                <br />
                <br />
                <br />
                <br />
                <v-row no-gutters>
                    <v-col cols="6" xs="12" sm="12" md="6" lg="6" xl="6" class="ml-n10" style="z-index:99">
                        <v-card elevatable="24" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="500">
                            <v-img :src="dash1" max-height="650" max-width="330"></v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="5" xs="12" sm="12" md="5" lg="5" xl="5" class="mr-n10 mt-13" style="z-index:9">
                        <v-card elevatable="10" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="1000">
                            <v-img :src="dash2" max-height="450" max-width="280"></v-img>
                        </v-card>
                    </v-col>
                </v-row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </v-col>
        </v-row>
        <br />
        <br />
        <v-row no-gutters class="mt-16">
            <v-col cols="1"></v-col>
            <v-col cols="4">
                <v-img :src="phone1" max-height="680" max-width="300" Contain class="myanimation mr-16"></v-img>
            </v-col>
            <v-col cols="6" class="mt-16">
                <v-row class="mt-6">
                    <v-col cols="6">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient( -45deg,#092ef1 0%,#010570 100%);color:white"
                                       fab>
                                    01
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    طراحی حرفه ای
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular'" class="mt-4 cardtext">
                                    طراحی تخصصی و انحصاری مخصوص اتوسرویس ها و مراکز تعویض روغن
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                    <v-col cols="6">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient(-45deg,#fab000 0%,#cd8400 100%);color:white"
                                       fab>
                                    02
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    طراحی حرفه ای
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular'" class="mt-4 cardtext">
                                    طراحی تخصصی و انحصاری مخصوص اتوسرویس ها و مراکز تعویض روغن
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                    <v-col cols="6" class="mt-3">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient(-45deg,#9ff300 0%,#1a8300 100%);color:white"
                                       fab>
                                    03
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    طراحی حرفه ای
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular'" class="mt-4 cardtext">
                                    طراحی تخصصی و انحصاری مخصوص اتوسرویس ها و مراکز تعویض روغن
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                    <v-col cols="6" class="mt-3">
                        <v-card shaped elevation="2" class="cardanimation">
                            <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient( -45deg,#BA5B12 0%,#1a8300 100%);color:white"
                                   fab>
                                04
                            </v-btn>
                            <v-card-title class="mt-6" style="font-weight:bold">
                                طراحی حرفه ای
                            </v-card-title>
                            <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular';" class="mt-4 cardtext">
                                طراحی تخصصی و انحصاری مخصوص اتوسرویس ها و مراکز تعویض روغن
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="1"></v-col>
        </v-row>
        <v-row class="mt-16">
            <v-col cols="1"></v-col>
            <v-col cols="5" class="mt-16">
                <!--1111-->
                <v-expansion-panels class="dropdownback" v-model="exp">
                    <v-expansion-panel class="test" id="expan" @click="expanClick()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon">mdi-account-group-outline</v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">چند کاربره</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content id="ex" style="color:white" class="mr-16">
                            لورم ایپسوم یا طرح‌ نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <!--222222-->
                <v-expansion-panels class="mt-6 dropdownback" v-model="exp2">
                    <v-expansion-panel class="test" id="expan2" @click="expan2Click()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader2">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon2">mdi-face-agent </v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">پشتیبانی کامل</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="color:white" class="mr-16">
                            لورم ایپسوم یا طرح‌ نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <!--33333-->
                <v-expansion-panels class="mt-6 dropdownback" v-model="exp3">
                    <v-expansion-panel id="expan3" @click="expan3Click()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader3">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon3">mdi-file-chart </v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">گزارشات متنوع</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="color:white" class="mr-16">
                            لورم ایپسوم یا طرح‌ نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <!--44444-->
                <v-expansion-panels class="mt-6 dropdownback" v-model="exp4">
                    <v-expansion-panel id="expan4" @click="expan4Click()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader4">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon4">mdi-store </v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">انبار داری</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="color:white" class="mr-16">
                            لورم ایپسوم یا طرح‌ نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col cols="5" class="mr-16 mt-16">
                <v-row no-gutters class="mr-16">
                    <v-col cols="5" class="ml-n10 mt-13" style="z-index:9">
                        <v-card elevatable="10" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="1000">
                            <v-img :src="dash2" max-height="450" max-width="280"></v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="6" class="mr-n10" style="z-index:99">
                        <v-card elevatable="24" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="500">
                            <v-img :src="dash1" max-height="650" max-width="330"></v-img>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="mt-16 mb-10 mx-5" style="background-color:white;border-top-right-radius:500px;border-top-left-radius:500px;border-bottom-left-radius:500px;border-bottom-right-radius:500px">
            <v-spacer></v-spacer>
            <v-col cols="3" class="mt-8">
                <v-hover v-slot="{ hover }"
                         open-delay="100">
                    <v-card style="border:thin" flat :elevation="hover ? 4 : 0" class="pricecard">
                        <v-card-title class="d-flex justify-center">
                            نرم افزار کاملا رایگان
                        </v-card-title>
                        <v-card-text class="d-flex justify-center">
                            <div class="price_icon pricecardicon">
                                <v-img :src="price2" contain max-height="150" max-width="250" class="mt-6"></v-img>
                            </div>
                        </v-card-text>
                        <v-card-text class="mt-3 pb-6">
                            <h5>پس از گذشت دوره تست و در صورت تمایل به بهره برداری از سامانه،نرم افزار آسا سرویس بصورت کاملا رایگان در اختیار مشتریان قرار خواهد گرفت.هزینه های بهره برداری طی قراردادی با توافق طرفین براساس مبلغی اندک به ازای هر سرویس ثبت شده در سامانه محاسبه و اخذ (به وسیله خود سامانه) می گردد</h5>
                        </v-card-text>
                        <br />
                    </v-card>
                </v-hover>

            </v-col>
            <v-col cols="3" class="mt-8">
                <v-hover v-slot="{ hover }"
                         open-delay="100">
                    <v-card style="border:solid;border-color:#FCFCFF" flat :elevation="hover ? 4 : 0" class="pricecard">
                        <v-card-title class="d-flex justify-center">
                            دوره تست رایگان بهره برداری
                        </v-card-title>
                        <v-card-text class="d-flex justify-center">
                            <div class="price_icon pricecardicon">
                                <v-img :src="price1" contain max-height="150" max-width="250" class="mt-6"></v-img>
                            </div>
                        </v-card-text>
                        <v-card-text class="mt-3">
                            <h5>با توجه به مزایای ویژه و انحصاری این سامانه و همچنین جهت آشنایی صاحبان کسب و کار با سامانه آسا سرویس،این مجموعه به مدت 20 روز(قابل تمدید) بهره برداری کامل از امکانات سامانه را در قالب دوره تست بصورت رایگان در اختیار مشتریان قرار خواهد داد و در پایان دوره در صورت رضایت از امکانات و تمایل به بهره برداری قرارداد همکاری منعقد میگردد</h5>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-16" no-gutters style="background-color:darkblue;height:650px">
            <v-col cols="1"></v-col>
            <v-col cols="3" class="mt-16">
                <v-row>
                    <h1 style="color:white;font-size:30px" class="mt-16">دریافت اپلیکیشن آساسرویس</h1>
                </v-row>
                <v-row>
                    <h6 style="color:white;font-size:15px" class="mt-16">آساسرویس، طراحی شده براساس <span style="color:#FFDE03">نیاز</span> مراکز تعویض روغن و برای مدیریت <span style="color:#FFDE03">جامع</span> فرآیندهای مراکز تعویض روغن</h6>
                </v-row>
                <v-row class="mt-16">
                    <v-btn elevation="2" style="font-weight:bold" class="downloadbtn"
                           outlined
                           x-large><v-icon right large class="pl-8">mdi-apple</v-icon>اپ استور</v-btn>
                </v-row>
                <v-row class="mt-6">
                    <v-spacer></v-spacer>
                    <a href="https://www.google.com" class="mr-16" style="font-weight:bold;font-size:15px;color:white;cursor:pointer;text-decoration:none;z-index:99"><v-icon color="white">mdi-file-pdf </v-icon>جهت دانلود فایل راهنما کلیک کنید</a>
                </v-row>
                <v-row class="mt-6">
                    <v-btn elevation="2" style="font-weight:bold" class="downloadbtn"
                           outlined
                           x-large><v-icon right large class="pl-8">mdi-android </v-icon>گوگل پلی</v-btn>
                </v-row>

            </v-col>
            <v-col></v-col>
            <v-col cols="6">
                <div v-bind:style="{ backgroundImage: 'url(' + shap + ')' }" class="shap">
                </div>
                <v-row class="mt-10">
                    <v-col cols="6"> <v-img :src="phone1" max-height="650" max-width="280" class="myanimation"></v-img></v-col>
                    <v-col cols="6"><v-img :src="phone1" max-height="650" max-width="280" class="myanimation"></v-img></v-col>
                </v-row>
            </v-col>
        </v-row>
        <br />
        <br />
        <br />
        <v-row class="mt-16" no-gutters>
            <v-row no-gutters>
                <v-col cols="2">
                    <v-row>
                        <h1 class="mr-10">آساسرویس در یک نگاه</h1>
                    </v-row>
                    <v-row>
                        <v-col cols="2"></v-col>
                        <v-col cols="8">
                            <v-progress-linear ress-linear color="deep-purple accent-4"
                                               indeterminate
                                               rounded
                                               reverse
                                               height="6"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <carousel-3d style="height:750px">
                <slide :index="0" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="1" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="2" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="3" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="4" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="5" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="6" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="7" style="height:740px">
                    <img :src="phone1" />
                </slide>
                <slide :index="8" style="height:740px">
                    <img :src="phone1" />
                </slide>
            </carousel-3d>
        </v-row>
        <v-footer class="mt-16" style="background-color:#1C2331;bottom:0">
            <v-row>
                <v-col cols="3">
                    <h1 style="color:white">آسمان کارمانیا</h1>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <h4 style="color:white" class="mt-16">شرکت دانش بنیان فناوری الکترونیک آسمان کارمانیا ارائه دهنده خدمات نرم افزاری و سخت افزاری با بالاترین کیفیت</h4>
                </v-col>
                <v-col cols="3">
                    <h1 style="color:white">محصولات</h1>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <v-row class="pr-6" style="color:white">
                        <h4>آسابیار</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4>آسایاب</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4>آسایار</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4>شفا</h4>
                    </v-row>
                </v-col>
                <v-col cols="3">
                    <h1 style="color:white">لینک های مفید</h1>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <v-row class="pr-6" style="color:white">
                        <h4>آسمان کارمانیا</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4>آسایاب</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4>فناوری کارمانیا</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4>help</h4>
                    </v-row>
                </v-col>
                <v-col cols="3">
                    <h1 style="color:white">ارتباط</h1>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <v-row class="pr-6" style="color:white">
                        <h4><v-icon color="white">mdi-home</v-icon> کرمان-خیابان میرزاآقاخان شمالی-خیابان رازی-پلاک148</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4><v-icon color="white">mdi-email</v-icon> fanavari.electronic@gmail.com</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4><v-icon color="white">mdi-phone mdi-rotate-270</v-icon> 09364444263</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4><v-icon color="white">mdi-fax</v-icon> 32265804</h4>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-btn color="#3B5998" class="ml-6"
                               fab
                               dark>
                            <v-icon large>mdi-send</v-icon>
                        </v-btn>
                        <v-btn color="#55ACEE" class="ml-6"
                               fab
                               dark>
                            <v-icon large>mdi-whatsapp</v-icon>
                        </v-btn>
                        <v-btn color="#D24736" class="ml-6"
                               fab
                               dark>
                            <v-icon large>mdi-google-plus </v-icon>
                        </v-btn>
                        <v-btn color="#007CC1" class="ml-6"
                               fab
                               dark>
                            <v-icon large>mdi-linkedin</v-icon>
                        </v-btn>
                        <v-btn color="#EC4A89" class="ml-6"
                               fab
                               dark>
                            <v-icon large>mdi-instagram</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-col>
                <v-col class="text-center" style="background-color:#161C27"
                       cols="12">
                    <v-icon style="color:#87867A">mdi-copyright</v-icon><span style="color:#87867A" class="ml-3">{{ new Date().getFullYear() }}</span> <strong style="color:#0275CD">کلیه حقوق برای آسمان کارمانیا محفوظ است</strong>
                </v-col>
            </v-row>
        </v-footer>
    </div>
    
</template>

<script>
    import 'animate.css';
    import { Carousel3d, Slide } from 'vue-carousel-3d';
    export default {
        name: 'Home',
        components: {
            Carousel3d,
            Slide
        },
        data() {
            return {
                test: "",
                exp: 1,
                exp2: 1,
                exp3: 1,
                exp4: 1,
                sidebar: false,
                menuItems: [{ title: 1 }, { title: 2 }, { title: 3 }, { title: 4 }, { title: 5 }, { title: 6 }]
            }
        },
        methods: {
            expanClick: function () {
                if (this.exp == 0) {
                    //document.getElementById("expan").style.backgroundColor = "white";
                    document.getElementById("expan").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader").style.color = '#8B8B99';
                    document.getElementById("expheadericon").style.color = '#7DDDE9';
                } else if (this.exp == undefined || this.exp == "" || this.exp == 1) {
                    document.getElementById("expan").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader").style.color = 'white';
                    document.getElementById("expheadericon").style.color = 'white';
                }
            },
            expan2Click: function () {
                if (this.exp2 == 0) {
                    document.getElementById("expan2").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader2").style.color = '#8B8B99';
                    document.getElementById("expheadericon2").style.color = '#7DDDE9';
                } else if (this.exp2 == undefined || this.exp2 == "" || this.exp2 == 1) {
                    document.getElementById("expan2").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader2").style.color = 'white';
                    document.getElementById("expheadericon2").style.color = 'white';
                }
            },
            expan3Click: function () {
                if (this.exp3 == 0) {
                    document.getElementById("expan3").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader3").style.color = '#8B8B99';
                    document.getElementById("expheadericon3").style.color = '#7DDDE9';
                } else if (this.exp3 == undefined || this.exp3 == "" || this.exp3 == 1) {
                    document.getElementById("expan3").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader3").style.color = 'white';
                    document.getElementById("expheadericon3").style.color = 'white';
                }
            },
            expan4Click: function () {
                if (this.exp4 == 0) {
                    document.getElementById("expan4").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader4").style.color = '#8B8B99';
                    document.getElementById("expheadericon4").style.color = '#7DDDE9';
                } else if (this.exp4 == undefined || this.exp4 == "" || this.exp4 == 1) {
                    document.getElementById("expan4").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader4").style.color = 'white';
                    document.getElementById("expheadericon4").style.color = 'white';
                }
            }
        },
        computed: {
            getLogo() {
                return this.$store.state.generalModule.logo;
            },
            phone() {
                return this.$store.state.generalModule.phone;
            },
            phone1() {
                return this.$store.state.generalModule.phone1;
            },
            phonedownalod() {
                return this.$store.state.generalModule.phonedownalod;
            },
            phonedownalod2() {
                return this.$store.state.generalModule.phonedownalod2;
            },
            dash1() {
                return this.$store.state.generalModule.dash1;
            },
            dash2() {
                return this.$store.state.generalModule.dash2;
            },
            background1() {
                return this.$store.state.generalModule.background1;
            },
            price1() {
                return this.$store.state.generalModule.price1;
            },
            price2() {
                return this.$store.state.generalModule.price2;
            },
            shap() {
                return this.$store.state.generalModule.shap;
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .myanimation {
        animation-name: example;
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }

    @keyframes example {
        0% {
        }

        50% {
            transition: transform 3s linear;
            transform: translateY(-10px);
        }

        100% {
            transition: transform 3s linear;
            transform: translateY(10px);
        }
    }

    .btnanimation {
        color: darkblue;
        background: linear-gradient(to right, darkblue 50%, white 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }

        .btnanimation:hover {
            background-position: left bottom;
            color: white
        }
    .cardanimation {
        color: darkblue;
        background: linear-gradient(to right, darkblue 50%, white 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }

        .cardanimation:hover {
            background-position: left bottom;
            color: white
        }

    .cardtext {
        color: #7B7B7B;
    }

    .cardanimation:hover .cardtext {
        color: white
    }
    .btnanimationicon {
        color: darkblue
    }

        .btnanimationicon:hover {
            color: white
        }

    .cardbtn {
        animation-name: cardbtnanim;
        animation-duration: 5s;
        animation-iteration-count: infinite;
    }

    @keyframes cardbtnanim {
        0% {
        }

        50% {
            -webkit-transform: scale(1.2);
            -ms-transform: scale(1.2);
            transform: scale(1.2);
        }
    }

    .price_icon {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background-color: rgba(3, 218, 246, 0.051);
        display: inline-block;
        position: relative;
        line-height: 200px;
        margin-top: 24px;
    }

    .pricecard {
        background-color: #FCFCFF;
    }

        .pricecard:hover {
            background-color: white
        }

    .pricecardicon {
        animation-name: pricecardiconanim;
        animation-duration: 5s;
        animation-iteration-count: infinite;
    }

    @keyframes pricecardiconanim {
        0% {
        }

        50% {
            -webkit-transform: scale(1.1);
            -ms-transform: scale(1.1);
            transform: scale(1.1);
        }
    }
</style>

